import { listRoutes as listGroupRoutes } from "./group";

export function listRoutes(domain) {
  return listGroups(domain).reduce(
    (acc, group) => [...acc, ...listGroupRoutes(group, { domain })],
    [
      {
        key: domain.id,
        type: "redirect",
        path: domain.url,
        props: { to: domain.defaultUrl }
      }
    ]
  );
}

export function listGroups(domain) {
  if (!domain) return [];
  return domain.groups || [];
}
